import { useEffect, useState } from "react";
import { Button, Col, Container, Form } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import { InputEdit } from "components";

import { useUsersApi } from "utils/hooks";

import "./Register.css";

function ErrorMessage({ message }) {
  return message ? (
    <Form.Group className="m-3">
      <h4 className="text-danger text-center">{message}</h4>
    </Form.Group>
  ) : null;
}

function SuccessMessage({ message }) {
  return message ? (
    <Form.Group className="m-3">
      <h4 className="text-success text-center">{message}</h4>
      <p className="text-center">
        <a href="/login" className="text-primary">
          Go to Login Page
        </a>
      </p>
    </Form.Group>
  ) : null;
}


export function RegisterUser() {
  const api = useUsersApi();

  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState("");

  const [errorMessage, setError] = useState(null);

  const [successMessage, setSuccess] = useState(null);

  const [formErrorMessage, setFormError] = useState(null);

  const [searchParams] = useSearchParams();

  const [tenantId, setTenantId] = useState(null);
  const [registerToken, setRegisterToken] = useState(null)

  const [userDetails, setUserDetails] = useState({});

  const verifyRegisterToken = async (tenantId,token) => {
    try {
      const response = await api.verifyUserRegisterToken(tenantId,token);
      return response;
    } catch (e) {
      setError("Expired invitation");
    }
  };

  const completeUserRegistration = async (tenantId,userDetails) => {
    try {
      const response = await api.registerUser(tenantId,registerToken, userDetails);

      setError(null);
      setSuccess(response.message);

      return response;
    } catch (e) {
      setError("Failed to register");
    }
  };

  useEffect(() => {
    const requiredToken = searchParams.get("token");
    const tenantId = searchParams.get("tenantId");
    setRegisterToken(requiredToken);
    
    if (verifyRegisterToken(tenantId,requiredToken)) {setTenantId(tenantId); setUserDetails({
      ...userDetails,
      token: requiredToken,
    });}
  }, []);

  return (
    <div className="classy-subtle-dark-gray-gradient">
      <Container>
        <Container className="d-flex align-items-center justify-content-center vh-100 login-container login-component-grow">
          <Col md={4}>
            <Form className="shadow  login-form" style={{ opacity: 0.9 }}>
              <Form.Group className="text-center">
                <img
                  src="/logo/logo.png"
                  width={200}
                  className="rounded img-responsive"
                  alt="ECHO Platform"
                />
              </Form.Group>

              <ErrorMessage message={errorMessage} />
              <SuccessMessage message={successMessage} />
              {!errorMessage && !successMessage && (
                <>
                  <Form.Group style={{ opacity: 1 }}>
                    <InputEdit
                      label={"First name"}
                      placeholder={"Enter your first name"}
                      //error={errorMessage}
                      onFocus={(e) => {
                        setFormError(null);
                      }}
                      onChange={(e) => {
                        setFormError(null);
                        setUserDetails({
                          ...userDetails,
                          first_name: e.target.value,
                        });
                      }}
                      onKeyDown={(e) => {
                        // Prevent numbers from being entered
                        if (!/^[a-zA-Z\s]*$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Group>
                  <Form.Group style={{ opacity: 1 }}>
                    <InputEdit
                      label={"Last name"}
                      placeholder={"Enter your last name"}
                      //error={errorMessage}
                      onFocus={(e) => {
                        setFormError(null);
                      }}
                      onChange={(e) => {
                        setFormError(null);
                        setUserDetails({
                          ...userDetails,
                          last_name: e.target.value,
                        });
                      }}
                      onKeyDown={(e) => {
                        // Prevent numbers from being entered
                        if (!/^[a-zA-Z\s]*$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Group>
                  <Form.Group style={{ opacity: 1 }}>
                    <InputEdit
                      label={"Password"}
                      type={"password"}
                      placeholder={"Enter your password"}
                      onFocus={(e) => {
                        setFormError(null);
                      }}
                      onChange={(e) => {
                        setFormError(null);
                        setUserDetails({
                          ...userDetails,
                          password: e.target.value,
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group style={{ opacity: 1 }}>
                    <InputEdit
                      label={"Confirm password"}
                      type={"password"}
                      placeholder={"Confirm your password"}
                      //error={errorMessage}
                      onFocus={(e) => {
                        setFormError(null);
                      }}
                      onChange={(e) => {
                        setFormError(null);
                        if (e.target.value !== userDetails.password)
                          setIsPasswordConfirmed(false);
                        else setIsPasswordConfirmed(true);
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="m-3" style={{ opacity: 1 }}>
                    <h4>
                      <p className="m-0 p-0 text-danger text-center">
                        {formErrorMessage}
                      </p>
                    </h4>
                  </Form.Group>

                  <Form.Group className="text-center">
                    <Button
                      type="submit"
                      lg={8}
                      className="btn btn-primary mt-3"
                      onClick={async (e) => {
                        e.preventDefault();

                        if (!userDetails.first_name) {
                          setFormError("First name could not be empty");
                          return;
                        }

                        if (!userDetails.last_name) {
                          setFormError("Last name could not be empty");
                          return;
                        }

                        if (userDetails.password.length < 7) {
                          setFormError(
                            "Password needs to be longer than 7 characters."
                          );
                          return;
                        }

                        if (!isPasswordConfirmed) {
                          setFormError("Password doesn't match");
                          return;
                        }

                        setFormError(null);

                        const response = await completeUserRegistration(
                          tenantId,
                          userDetails
                        );
                      }}
                    >
                      Register
                    </Button>
                  </Form.Group>
                </>
              )}
            </Form>
          </Col>
        </Container>
      </Container>
    </div>
  );
}
